import { Typography } from '@figure/frontlib-gui';
import ReviewAppBase from '../components/ReviewAppBase';

const UnderwritingContainer = () => (
  <ReviewAppBase>
    <Typography.Body>
      We are reviewing your application, and will be in touch soon. You can typically expect to hear from us within 72 hours, and we
      thank you for your patience. You can check the status of your application on the dashboard, but will not be able to continue
      until your application has been reviewed. You will be notified when action is required of you.
    </Typography.Body>
  </ReviewAppBase>
);

export default UnderwritingContainer;
